import { Component } from '@angular/core';
import { LoaderService } from 'src/app/services/loader/loader.service';
@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
	loading = false;
	constructor(public loaderSrv: LoaderService) {}
	ngOnInit() {
		this.loaderSrv.loading$.subscribe((val) => {
			this.loading = val;
		});
	}
}
